<div
  *transloco="
    let t;
    scope: 'featureDataManagement';
    prefix: 'featureDataManagement'
  "
  data-id="manage-attributes-container"
  class="h-full flex flex-col"
>
  <bd-page-header
    class="mt-[28px]"
    [titleText]="{
      textKey: 'dataManagement.label',
      tScope: 'featureDataManagement',
    }"
  />
  <div class="bd-page-container flex-1 flex flex-col">
    <h6 data-id="manage-attributes-title">
      {{ t('manageAttributes.label') }}
    </h6>
    <div class="mt-8 grid grid-cols-2 gap-6 grow">
      <div>
        <div class="w-9/12">
          <bd-dropdown
            data-id="object-type-selector"
            [options]="objectTypeOptions"
            [(singleSelection)]="selectedObjectType"
            [settings]="{
              tScope: 'featureDataManagement',
              dropdownLabelKey: 'manageAttributes.selectObjectType.label',
              inputPlaceholderKey:
                'manageAttributes.selectObjectType.placeholder',
              inputType: 'default',
              layout: 'list',
              selectionMode: 'single',
              dropdownWidth: '30rem',
            }"
          />
        </div>
        @if (isCategorySelectionReady$ | async) {
          <div class="w-9/12">
            <bd-category-selector
              [existingCategories]="existingCategories$ | async"
              (selectedCategory)="onCategorySelected($event)"
            />
          </div>
          @if (isAttributesEditingReady$ | async) {
            <div class="mt-8 pt-6">
              <bd-attributes-editor
                [existingAttributes]="existingAttributes$ | async"
                (newAttributes)="onNewAttributes($event)"
              >
              </bd-attributes-editor>
            </div>
          }
        }
      </div>
      <div>
        <bd-attribute-category-definitions-list
          data-id="manage-attributes-attribute-category-definitions"
          [objectType]="selectedObjectType$ | async"
          [attrCatDefs]="(attrCatDefs$ | async)?.categories"
          [loading]="(loading$ | async) ?? false"
        />
      </div>
    </div>
    <div class="flex self-end justify-end mt-8">
      <p-button
        class="mr-4"
        [outlined]="true"
        [label]="t('cancelButton')"
        (onClick)="onCancelClick()"
        data-id="manage-attributes-cancel-button"
      ></p-button>
      <p-button
        [label]="t('confirmButton')"
        [disabled]="!(isChangeReady$ | async)"
        (onClick)="onConfirmClick()"
        data-id="manage-attributes-confirm-button"
      ></p-button>
    </div>
    @if (completionDialogSettings$ | async; as dialogSettings) {
      <bd-status-dialog
        [dialogSettings]="
          dialogSettings ?? {
            display: false,
            status: 'failure',
          }
        "
        (dismiss)="onCompletionDialogClose()"
      />
    }
  </div>
</div>
